<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3" v-if="$validate.DataValid(this.id)">
              <FormSelect
                label="grade"
                placeholder="selectGrade"
                :fieldValue.sync="formData.grade"
                :options="$store.getters.gradeOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-else>
              <FormSelect
                label="grade"
                placeholder="selectGrade"
                :fieldValue.sync="formData.grade_list"
                :options="$store.getters.gradeOptions"
                required
                isMultiple
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="courseCategory"
                placeholder="selectCourseCategory"
                :fieldValue.sync="formData.category_id"
                :options="categoryOptions"
                required
                @changed="formData.schools = []"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.schools"
                :options="tutorSchoolOptions"
                required
                isMultiple
                :noDataText="$validate.DataValid(formData.category_id) ? 'noOption' : 'selectCourseCategoryFirst'"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'CourseDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
    FormInput,
    FormSelect,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
    tutorSchoolOptions() {
      if (
        this.$validate.DataValid(this.tutorSchoolData) &&
        this.$validate.DataValid(this.categoryOptions) &&
        this.$validate.DataValid(this.formData.category_id)
      ) {
        const targetCate = this.categoryOptions.find(el => el.value === this.formData.category_id)
        if (targetCate) {
          const validSchools = this.tutorSchoolData.filter(el => targetCate.schools.includes(el.id))
          const list = validSchools.map(el => {
            return {
              value: el.id,
              text: el.name,
            }
          })
          list.unshift({ value: -1, text: this.$t('allCenters') })
          return list
        }
      }

      return []
    },
  },
  data: () => ({
    formData: {
      grade: null,
      grade_list: [],
      name: '',
      category_id: null,
      schools: [],
    },
    categoryOptions: [],
    tutorSchoolData: null,
  }),
  methods: {
    async _getCourseById() {
      try {
        const data = await this.$Fetcher.GetCourseById(parseInt(this.id))
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        const foundAllOption = this.tutorSchoolOptions.find(el => el.value === -1)
        if (foundAllOption) {
          let isAllSchool = true
          for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
            if (this.tutorSchoolOptions[i].value !== -1) {
              const found = this.formData.schools.find(el => el === this.tutorSchoolOptions[i].value)
              if (!found) {
                isAllSchool = false
                break
              }
            }
          }
          if (isAllSchool) {
            this.formData.schools.push(-1)
          }
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'CourseList',
          })
        }
      }
    },
    async _getAllSchoolData() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        this.tutorSchoolData = filtered
      } catch (err) {
        this.$common.error(err)
      }
    },
    async _getAllCourseCategoryOptions() {
      try {
        let payload = {}
        const selectedSchool = this.gfGetUserSelectedSchool()
        if (selectedSchool > -1) {
          payload['center_id'] = selectedSchool
        }

        const { data } = await this.$Fetcher.GetCourseCategories(payload)
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.categoryOptions = filtered.map(el => {
            return {
              value: el.id,
              text: el.name,
              schools: el.schools,
            }
          })
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    // -- (確認)
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      let payload = {
        category_id: this.formData.category_id,
        name: this.formData.name,
        schools: this.formData.schools.filter(el => el !== -1),
      }
      if (this.$validate.DataValid(this.id)) {
        payload['grade'] = this.formData.grade
        // edit
        try {
          await this.$Fetcher.UpdateCourse(this.id, payload)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
            refresh: true,
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      } else {
        // create
        this._createCourseServer(payload)
      }
    },
    async _createCourseServer(payload, count = 0) {
      if (count < this.formData.grade_list.length) {
        try {
          const p = {
            ...payload,
            grade: this.formData.grade_list[count],
          }
          await this.$Fetcher.NewCourse(p)
          count += 1
          this._createCourseServer(payload, count)
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
            returnLink: 'CourseList',
          })
        }
      } else {
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.createSuccess',
          type: 'success',
          redirect: 'CourseList',
        })
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteCourse(this.id, true)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'CourseList',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: CourseDetails')
      await this._getAllSchoolData()
      await this._getAllCourseCategoryOptions()
      if (this.$validate.DataValid(this.id)) {
        await this._getCourseById()
      }
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
